import { render, staticRenderFns } from "./CmgMealBuilderMobileItemSelectorCard.vue?vue&type=template&id=cd4e894e&scoped=true&lang=pug"
import script from "./cmg-meal-builder-mobile-item-selector-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-meal-builder-mobile-item-selector-card.ts?vue&type=script&lang=ts&external"
import style0 from "./cmg-meal-builder-mobile-item-selector-card.scss?vue&type=style&index=0&id=cd4e894e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4e894e",
  null
  
)

export default component.exports